// @flow
import type { GlobalState } from '../rootReducer';

/* Action Types */
export const CHANGE_MORE_ITEMS_FROM_CATALOG_INDEX = 'CHANGE_MORE_ITEMS_FROM_CATALOG_INDEX';

// reducer
const DEFAULT_STATE = {};

export type State = {
    ...typeof DEFAULT_STATE,
};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case CHANGE_MORE_ITEMS_FROM_CATALOG_INDEX:
            return {
                ...state,
                [action.payload.itemId]: action.payload.newIndex,
            };
        default:
            return state;
    }
}

/* SELECTORS */
export const getMoreItemsFromCatalogIndex = (state: GlobalState, itemId: number, fallbackIndex?: number) =>
    state.moreItemsFromCatalogIndex[itemId] !== undefined
        ? state.moreItemsFromCatalogIndex[itemId]
        : fallbackIndex || 0;

/* ACTION CREATORS */
export const changeMoreItemsFromCatalogIndex = (itemId: number, newIndex: number) => ({
    payload: { itemId, newIndex },
    type: CHANGE_MORE_ITEMS_FROM_CATALOG_INDEX,
});
